<template>
  <div>
    <Card>
      <Row>
        <Button type="info"
                @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate :columns="columns"
                     :data="desk_partitions"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_desk_partition_index_480')">
      <Form ref="category"
            :model="desk_partition"
            :label-width="80">
        <Form-item :label="$t('pages_desk_partition_index_481')"
                   prop="name">
          <Input type="text"
                 v-model="desk_partition.name" />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'
import { localRead } from '@/libs/util'

export default {
  components: {
    TablePaginate,
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: 'id',
          key: 'id'
        },
        {
          title: i18n.t('pages_desk_partition_index_481'),
          key: 'name'
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapGetters('setting', ['setting']),
    ...mapState('desk_partition', ['desk_partition', 'desk_partitions', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('desk_partition', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('desk_partition', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      this.desk_partition.shop_id = localRead('SHOPID')
      if (this.formType === 'edit') {
        await this.update(this.desk_partition)
      } else if (this.formType === 'new') {
        await this.create(this.desk_partition)
      }
      this.modalShow = false
    },
  }
}
</script>
